import { CSSProperties, ReactNode, useRef } from 'react';
import { SignInModal } from '@coinbase/cdp-react';
import { LoadingSpinner } from '@coinbase/cdp-react/components/ui/LoadingSpinner';
import { useUser } from 'apps/cdp-web-demo/app/(main)/UserContext';
import { Box } from '@cbhq/cds-web/layout';

import { LoggedInView } from '../LoggedInView/LoggedInView';

import styles from './DemoContent.module.css';

type DemoContentProps = {
  children?: ReactNode;
  className?: string;
  style?: CSSProperties;
};

export function DemoContent({ children, className = '', style }: DemoContentProps) {
  const contentRef = useRef<HTMLDivElement>(null);
  const { isInitialized, isLoggedIn, isModalVisible, setIsModalVisible, onSignInSuccess } =
    useUser();

  return (
    <Box
      ref={contentRef}
      alignItems="center"
      justifyContent="center"
      flexGrow={1}
      className={`page ${styles.page} ${className}`}
      style={style}
    >
      {!isInitialized && <LoadingSpinner className={styles.loading} />}
      {isInitialized && (
        <>
          {isLoggedIn && <LoggedInView className={styles.loggedIn} />}
          {!isLoggedIn &&
            (children ?? (
              <SignInModal
                open={isModalVisible}
                setIsOpen={setIsModalVisible}
                onSuccess={onSignInSuccess}
              />
            ))}
        </>
      )}
    </Box>
  );
}
